module.exports = __webpack_public_path__ + "img/icon-icon-blog-g.c27c858c.svg";